import { Country } from "@/helpers/generateSiteMap";
import { globalErrorHandler } from "@/helpers/globalResponseHandler";
import { api } from "@/lib/fetch/apiSetup";
import { ApiResponse } from "@/types/api/API";
import {
  SearchPackagesList,
  SearchPackagesListReturn,
} from "@/types/packages/data-only/SearchPackagesList";
import {
  TopDestination,
  TopDestinationsResponse,
} from "@/types/packages/data-only/TopDestinations";
import { Locale } from "next-intl";

export async function searchPackagesList({
  locale,
}: {
  locale: Locale;
}): Promise<ApiResponse<SearchPackagesListReturn>> {
  try {
    const response = await api<SearchPackagesList>(
      `/search-package-list`,
      null,
      locale,
    );
    const {
      global,
      global_voice,
      local,
      local_voice,
      regional,
      regional_voice,
    } = response.data;

    const globalDataOnly: { href: string; countries: Country[] } = {
      href: "global",
      countries: global,
    };

    const localDataOnly = local.map((country) => ({
      ...country,
      href: `/esim/${country.slug}/`,
    }));

    const regionalDataOnly = regional.map((region) => ({
      ...region,
      href: `/regional/${region.slug}/`,
    }));

    const globalDataVoice: { href: string; countries: Country[] } = {
      href: "/global/?package_type=data-voice",
      countries: global_voice.flatMap((item) => item.countries),
    };

    const localDataVoice = local_voice.map((country) => ({
      ...country,
      href: `/esim/${country.slug}/?package_type=data-voice`,
    }));

    const regionalDataVoice = regional_voice.map((region) => ({
      ...region,
      href: `/regional/${region.slug}/?package_type=data-voice`,
    }));

    return {
      status: true,
      data: {
        global: globalDataOnly,
        local: localDataOnly,
        regional: regionalDataOnly,
        global_voice: globalDataVoice,
        local_voice: localDataVoice,
        regional_voice: regionalDataVoice,
      },
    };
  } catch (error) {
    return { status: false, message: globalErrorHandler(error) };
  }
}

export async function getTopDestinations({
  locale,
}: {
  locale: Locale;
}): Promise<ApiResponse<TopDestination[]>> {
  try {
    const response = await api<TopDestinationsResponse>(
      `/top-destinations`,
      null,
      locale,
    );
    return { status: true, data: response.data };
  } catch (error) {
    return { status: false, message: globalErrorHandler(error) };
  }
}
